module.exports = __webpack_public_path__ + "img/kiinara_light.61fb52f9.svg";